import SsoApi from "../api/Api/SsoApi";
import { defineStore } from "pinia";
import { isEmpty } from "lodash";
export const useUserStore = defineStore("user", {
  state: () => ({
    user: {},
    users: [],
    staffUsers: null,
    loading: false,
    loadingOrgUsers: false,
  }),
  getters: {
    isLoggedIn: (state) => !!state.user && !isEmpty(state.user),
    isStaff(state) {
      return this.isLoggedIn && state.user.isStaff && state.user.hasAppAccount;
    },
    isCommitteeMember(state) {
      return (
        this.isLoggedIn &&
        state.user.isCommitteeMember &&
        state.user.hasAppAccount
      );
    },
    isImpersonating(state) {
      return this.isLoggedIn && state.user.isImpersonating;
    },
    isNcaaAppAdmin(state) {
      return (
        this.isLoggedIn && state.user.isNcaaAppAdmin && state.user.hasAppAccount
      );
    },
    isInstitution(state) {
      return (
        this.isLoggedIn && state.user.isInstitution && state.user.hasAppAccount
      );
    },
  },
  actions: {
    async fetchUser() {
      this.loading = true;
      return SsoApi.fetchUser()
        .then((response) => {
          this.user = response;
        })
        .finally(() => (this.loading = false));
    },
    async fetchUsers(orgId) {
      this.loadingOrgUsers = true;
      return SsoApi.users({ query: { orgId } })
        .then((response) => {
          this.users = response;
        })
        .finally(() => (this.loadingOrgUsers = false));
    },
    clearUser() {
      this.user = null;
    },
  },
});
